import { useCallback, useEffect, useState } from 'react';
import { BraveBupAPI } from '@BUP/services/Axios';

// Hook que encuentra la los estudiantes correspondientes al curso del profesor jefe
export const useGetCourseStudentsSociogram = (user) => {
  const organizationId = user?.organizations?.id;
  const courseId = user?.courseId;
  const [listState, setListState] = useState({
    isLoadingStudents: false,
    studentsList: {},
    errorStudents: null,
  });

  const getStudents = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const { data } = await BraveBupAPI.get(
        `users?organizationId=${organizationId}&roleType=STUDENT&courseId=${courseId}&size=300`
      );
      const students = data?.data;
      // Ordenando alfabéticamente los nombres de los estudiantes
      students?.sort((obj1, obj2) => {
        if (obj1.name < obj2.name) {
          return -1;
        }
        if (obj1.name > obj2.name) {
          return 1;
        }
        return 0;
      });

      setListState((prevState) => ({
        ...prevState,
        students,
      }));
    } catch (error) {
      console.log('error', error);
      setListState((prevState) => ({
        ...prevState,
        error,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  }, [setListState, organizationId, courseId]);

  useEffect(() => {
    getStudents();
  }, [getStudents, organizationId, courseId]);

  return {
    isLoadingStudents: listState.isLoading,
    studentsList: listState.students,
    errorStudents: listState.error,
  };
};
